// react-native/Libraries/Utilities/codegenNativeComponent is a Fabric-only
// codegen entry (used by react-native-svg's native component specs). It has no
// meaning on web. Return a null-rendering component so the native specs resolve
// without dragging in RN core Flow source. (For full SVG fidelity, Phase 2
// should resolve react-native-svg's own *.web.js build instead.)
function codegenNativeComponent() {
  return function NativeComponentStub() {
    return null;
  };
}
module.exports = codegenNativeComponent;
module.exports.default = codegenNativeComponent;
